/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: SuccessStoriesPage
 * Page name: Success Strories page
 * Page Description: This is the success story page of the website of Ekathva Innovations.
 */

import React,{ Component } from 'react'
import MetaTags from 'react-meta-tags'
import { Container, Col, Row, Button } from 'react-bootstrap'
import Aos from 'aos'
import LandingPageSuccessStories from 'components/Headers/LandingPageSuccessStories'
import Navbar from "components/Navbars/Navbar";
import Footer from 'components/Footers/Footer'

import 'assets/style/Style.css'

//Snapshots IT
import IBBANI from "assets/images/Snapshots/IBBANIs.png"
import VTECH from "assets/images/Snapshots/VTECHs.png"
import ROOTSGOODS from "assets/images/Snapshots/ROOTSGOODSs.png"
import RootsGoods_App from "assets/images/Snapshots/RootsGoods_App.png"
import MONICA from "assets/images/Snapshots/MONICAs.png"
import GFGC from "assets/images/Snapshots/GFGCs.png"
import GLWC from "assets/images/Snapshots/GLWCs.png"
import VAML from "assets/images/Snapshots/VAMLs.png"
import MORINGA from "assets/images/Snapshots/MORINGAs.png"
import VISHWA from "assets/images/Snapshots/VISHWAs.png"
import SUMUKHA from "assets/images/Snapshots/SUMUKHAs.png"
import MALNAD from "assets/images/Snapshots/MALNADs.png"
import SCHOLAR from "assets/images/Snapshots/SCHOLARs.png"
import ISVM from "assets/images/Snapshots/ISVMs.png"
import CLINICALs from "assets/images/Snapshots/CLINICALs.png"
import RGA from "assets/images/Snapshots/RGA.jpg"
import CSIs from "assets/images/Snapshots/CSIs.png"
import DSCs from "assets/images/Snapshots/DSCs.png"
import Technorings from "assets/images/Snapshots/TL.png"
import EILEARN from "assets/images/Snapshots/EILEARN.png"
import AMSTs from "assets/images/Snapshots/AMSTs.png"
//Embedded
import FingerPrinting from "assets/images/EmbeddedService/FPU.png"
import OilBlending from "assets/images/EmbeddedService/OilBlending.jpg"
import TimeLogger from "assets/images/EmbeddedService/TimeLogger.jpg"
import WirelessMotor from "assets/images/EmbeddedService/WirelessMotor.jpg"
import PST from "assets/images/EmbeddedService/PST.png"

class SuccessStories extends Component {

  constructor(props) {
    super(props)

  };

    componentDidMount() {
      // this is needed, because InfiniteCalendar forces window scroll
      window.scrollTo(0, 0);
    }

    render() {

    return (
    <div>
        <MetaTags>
            <title>Success Stories - Our works | Ekathva Innovations Pvt Ltd</title>
            <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
        </MetaTags>
            <Navbar/>
            <LandingPageSuccessStories/>
            <br/>

            <div id='SS1' className='aboutus_mainspace' ref={this.SS1}>
                <br/>
                <h6 data-aos="fade-right" className='successstories_headingalign' >Ibbani Food Industries</h6>
                <br/>

                <div className='successstories_contentspace successstories_imagedisplay2' >
                    <Row className="justify-content-md-">
                        <Col xs lg="5" data-aos="fade-right" >
                            <div>
                        <img src={IBBANI} alt='Ibbani Food Industries Website snapshot photo' />
                            </div>
                        </Col>
                        <Col data-aos="fade-left" >
                        <p>
                            <strong>
                            E-commerce website for Ibbani Food industries which manufactures and promotes high quality
                            processed masala powders, pickles, papads, herbal powder, honey and Malenadu special products.
                            </strong>
                        </p>
                        <Button href="http://www.ibbanifoods.com/" variant="outline-danger" size="sm" target="_blank">Visit website</Button>
                        </Col>
                    </Row>
                </div>

                <div className='successstories_contentspace successstories_imagedisplay1' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={IBBANI} alt='Ibbani Food Industries Website snapshot photo'  />
                            </div>
                        <p>
                            <strong>Business website for V-Tech Engineers who invented Areca nut dehusking
                            machine, which was the first of its kind in history. Website includes all the innovative Agri products
                            from the company.
                        </strong>
                            </p>
                        <Button href="http://www.ibbanifoods.com/" variant="outline-danger" size="sm" target="_blank">Visit website</Button>
                        </Col>
                    </Row>
                </div>


            </div>

            <div id='SS2' className='aboutus_mainspace products_backgroundcolor' ref={this.SS2}>
                    <br/>
                    <h6 data-aos="fade-right" className='successstories_headingalign' >V-Tech Engineers</h6>
                    <br/>
                    <div className='successstories_contentspace' >
                        <Row className="justify-content-md-center">
                            <Col data-aos="fade-right">
                                <div>
                                    <img src={VTECH} alt='V-tech Engineers Website snapshot photo' className='successstories_imagedisplay1' />
                                </div>
                                <p>
                                    <strong>
                                        Business website for V-Tech Engineers who invented Areca nut dehusking
                                        machine, which was the first of its kind in history. Website includes all the innovative Agri products
                                        from the company.
                                    </strong>
                                </p>
                                <Button href="http://www.vtechengineer.com/" variant="outline-danger" size="sm" target="_blank">Visit website</Button>
                            </Col>
                            <Col xs lg="5" className='successstories_imagedisplay2'  >
                                <div>
                                    <img src={VTECH} alt='V-tech Engineers Website snapshot photo'/>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>

            <div id='SS3' className='aboutus_mainspace' ref={this.SS3}>
                <br/>
                <h6 data-aos="fade-right" className='successstories_headingalign' >RootsGoods OPC Pvt Ltd</h6>
                <br/>

                <div  className='successstories_contentspace successstories_imagedisplay2' >
                    <Row className="justify-content-md-center">
                        <Col  xs lg="5">
                        <img src={ROOTSGOODS} alt='RootsGoods Opc Pvt Ltd Website snapshot photo ' />
                        </Col>
                        <Col data-aos="fade-left">
                        <p>
                        <strong>
                            Corporate website for RootsGoods which is an interactive, state of
                            the art technology, multi disciplinary platform with proprietary software
                            and hardware tools for farmers to maintain, grade, sell and transport their
                            commodities from farms to wholesale buyers' address.
                        </strong>
                        </p>
                        <Button href='https://www.rootsgoods.com/'  variant="outline-danger" size="sm" target="_blank" target="_blank">Visit website</Button>
                        </Col>
                    </Row>
                </div>

                <div className='successstories_contentspace successstories_imagedisplay1' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={ROOTSGOODS} alt='RootsGoods Opc Pvt Ltd Website snapshot photo ' />
                            </div>
                        <p>
                            <strong>
                                Corporate website for RootsGoods which is an interactive, state of
                                the art technology, multi disciplinary platform with proprietary software
                                and hardware tools for farmers to maintain, grade, sell and transport their
                                commodities from farms to wholesale buyers' address.
                            </strong>
                            </p>
                        <Button href="https://www.rootsgoods.com/" variant="outline-danger" size="sm" target="_blank">Visit website</Button>
                        </Col>
                    </Row>
                </div>

                <div >
                    <br/>
                    <br/>
                    <div id='SS4' className='successstories_contentspace' ref={this.SS4}>
                        <Row className="justify-content-md-center">
                            <Col data-aos="fade-right">
                                <div className='successstories_imagedisplay1' >
                                    <img src={MORINGA} alt='RootsGoods Opc Pvt Ltd Website snapshot photo '/>
                                </div>
                                <p>
                                    <strong>
                                    Landing page website for products of Moringa from RootsGoods. Moringa oleifera is a plant native to northern India that can also grow in other tropical and subtropical places, like Asia and Africa.
                                    </strong>
                                </p>
                                <Button href="https://www.moringa.rootsgoods.com/" variant="outline-danger" size="sm" target="_blank">Visit website</Button>
                            </Col>
                            <Col  xs lg="5"  className='successstories_imagedisplay2' >
                                <div>
                                    <img src={MORINGA} alt='RootsGoods Opc Pvt Ltd Website snapshot photo ' />
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div>
                        <h6 id='SS5' className='successstories_headingalign' ref={this.SS5}></h6>
                        <br/>
                        <div className='successstories_contentspace' >
                            <Row className="justify-content-md-center">
                                <img src={RootsGoods_App} className='successstories_rootsgoodsapp' alt='RootsGoods Opc Pvt Ltd App snapshot photo ' />
                                <Col data-aos="fade-left">
                                    <p>
                                        <strong>
                                            Android and iOS mobile application by RootsGoods which is a platform for farmers to
                                            maintain, sell and transport their commodities from farms to wholesale buyers via logistics
                                            enabled within the app.<br/></strong>
                                    </p>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div>

            <div className='aboutus_mainspace products_backgroundcolor'>
                <br/>
                <h6 data-aos="fade-right" id='SS6' className='successstories_headingalign' ref={this.SS6}>Monica Kulkarni</h6>
                <br/>
                <div  className='successstories_contentspace' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={MONICA} alt='Monica Kulkarni Website snapshot photo' className='successstories_imagedisplay1' />
                            </div>
                        <p>
                        <strong>
                            Portfolio website for a professional photographer to showcase portraits and
                            stills beautifully captured in her camera! </strong>
                        </p>
                        <Button href='http://www.monicakulkarni.com/'  variant="outline-danger" size="sm" target="_blank">Visit website</Button>
                        </Col>
                        <Col  xs lg="5"  className='successstories_imagedisplay2' >
                            <div>
                                <img src={MONICA} alt='Monica Kulkarni Website snapshot photo' />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <div id='SS7' className='aboutus_mainspace' ref={this.SS7}>
                <br/>
                <h6 data-aos="fade-right" id='SS7' className='successstories_headingalign' >Government First Grade College</h6>
                <br/>

                <div className='successstories_contentspace successstories_imagedisplay2' >
                    <Row className="justify-content-md-">
                        <Col xs lg="5" data-aos="fade-right" >
                            <div>
                        <img src={GFGC} alt='Government First Grade College Website snapshot photo' />
                            </div>
                        </Col>
                        <Col data-aos="fade-left" >
                        <p>
                        <strong>
                            Educational Institutional website for Government First Grade College,
                            Kalasa, that includes all the details about the institution, from facilities
                            to faculties, from academic information to Student friendly blog. This also
                            includes courses offered and co-curricular activities encouraged by the institution.</strong>
                        </p>
                        <Button href='http://gfgckalasa.edu.in/'  variant="outline-danger" size="sm" target="_blank">Visit website</Button>
                        </Col>
                    </Row>
                </div>

                <div className='successstories_contentspace successstories_imagedisplay1' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={GFGC} alt='Government First Grade College Website snapshot photo' />
                            </div>
                            <p>
                        <strong>
                            Educational Institutional website for Government First Grade College,
                            Kalasa, that includes all the details about the institution, from facilities
                            to faculties, from academic information to Student friendly blog. This also
                            includes courses offered and co-curricular activities encouraged by the institution.</strong>
                        </p>
                        <Button href='http://gfgckalasa.edu.in/'  variant="outline-danger" size="sm" target="_blank">Visit website</Button>
                        </Col>
                    </Row>
                </div>
            </div>

            <div className='aboutus_mainspace products_backgroundcolor'>
            <br/>
                <h6 data-aos="fade-right" id='SS8' className='successstories_headingalign' ref={this.SS8} >GLWC-KAR</h6>
                <br/>
                <div className='successstories_contentspace' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={GLWC} alt='Rajya Sarkari Padavi Collegegala Atithi Upanyasakara
                            HitaRakshana Samithi Website snapshot photo' className='successstories_imagedisplay1' />
                            </div>
                        <p>
                        <strong>
                            Organization website for Rajya Sarkari Padavi Collegegala Atithi Upanyasakara
                            HitaRakshana Samithi, Karnataka, which is a welfare committee of guest lecturers
                            who are currently working across Karnataka State Government Degree Colleges.
                            It also includes the online membership for the committee, a step closer towards
                            fully digitized organization.</strong>
                        </p>
                        <Button href="https://glwc-kar.org/#/index" variant="outline-danger" size="sm" target="_blank">Visit website</Button>
                        </Col>
                        <Col  xs lg="5"  className='successstories_imagedisplay2'  >
                            <div>
                                <img src={GLWC} alt='Rajya Sarkari Padavi Collegegala Atithi Upanyasakara
                            HitaRakshana Samithi Website snapshot photo'/>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <div id='SS9' className='aboutus_mainspace' ref={this.SS9} >
                <br/>
                <h6 data-aos="fade-right" id='SS9' className='successstories_headingalign' >V Tech Automotors Ltd</h6>
                <br/>

                <div className='successstories_contentspace successstories_imagedisplay2' >
                    <Row className="justify-content-md-">
                        <Col xs lg="5" data-aos="fade-right" >
                            <div>
                        <img src={VAML} alt='V-tech Automotors Ltd Website snapshot photo' />
                            </div>
                        </Col>
                        <Col data-aos="fade-left" >
                        <p>
                        <strong>
                            Landing page website for V-Tech Automotors Ltd, one of the leading EV Manufacturing
                            industries with a wide range of electric scooters with affordable and user friendly conditions.</strong>
                        </p>
                        <Button href="https://www.vaml.in/" variant="outline-danger" size="sm" target="_blank">Visit website</Button>
                        </Col>
                    </Row>
                </div>

                <div className='successstories_contentspace successstories_imagedisplay1' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={VAML} alt='V-tech Automotors Ltd Website snapshot photo' />
                            </div>
                            <p>
                        <strong>
                            Landing page website for V-Tech Automotors Ltd, one of the leading EV Manufacturing
                            industries with a wide range of electric scooters with affordable and user friendly conditions.</strong>
                        </p>
                        <Button href="https://www.vaml.in/" variant="outline-danger" size="sm" target="_blank">Visit website</Button>
                        </Col>
                    </Row>
                </div>
            </div>

            <div className='aboutus_mainspace products_backgroundcolor'>
            <br/>
                <h6 data-aos="fade-right" id='SS10' className='successstories_headingalign' ref={this.SS10} >Vishwabhushana Trust</h6>
                <br/>
                <div className='successstories_contentspace' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={VISHWA} alt='Vishwabhushana Trust Website snapshot photo' className='successstories_imagedisplay1' />
                            </div>
                        <p>
                        <strong>
                            Organization website for Vishwabhushana trust is one of the society-oriented organizations
                            working for the well-being of the society from Blood donation camp to eye-donation driving camp,
                            from Vanamahotsava, to eco-natural trips and invited talks for school students in various topics.</strong>
                        </p>
                        <Button href="http://www.vishwabhushanatrust.org/" variant="outline-danger" size="sm" target="_blank">Visit website</Button>
                        </Col>
                        <Col  xs lg="5" className='successstories_imagedisplay2'>
                            <div>
                                <img src={VISHWA} alt='Vishwabhushana Trust Website snapshot photo'/>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <div id='SS11' className='aboutus_mainspace' ref={this.SS11}>
                <br/>
                <h6 data-aos="fade-right" id='SS11' className='successstories_headingalign' >Sumuka Steels Pvt Ltd</h6>
                <br/>

                <div className='successstories_contentspace successstories_imagedisplay2' >
                    <Row className="justify-content-md-">
                        <Col xs lg="5" data-aos="fade-right" >
                            <div>
                        <img src={SUMUKHA} alt='Sumukha Steels Pvt Ltd Website snapshot photo' />
                            </div>
                        </Col>
                        <Col data-aos="fade-left" >
                        <p>
                        <strong>
                            Corporate website for the steel industry with modern manufacturing complex comprising pattern shop,
                            moulding, melting, fettling, heat treatment, shot blasting and other testing facilities required
                            for production of steel and alloy steel castings with reliable quality.</strong>
                        </p>
                        <Button href="http://www.sumukasteels.com/" variant="outline-danger" size="sm" target="_blank">Visit website</Button>
                        </Col>
                    </Row>
                </div>

                <div className='successstories_contentspace successstories_imagedisplay1' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={SUMUKHA} alt='Sumukha Steels Pvt Ltd Website snapshot photo' />
                            </div>
                            <p>
                        <strong>
                            Corporate website for the steel industry with modern manufacturing complex comprising pattern shop,
                            moulding, melting, fettling, heat treatment, shot blasting and other testing facilities required
                            for production of steel and alloy steel castings with reliable quality.</strong>
                        </p>
                        <Button href="http://www.sumukasteels.com/" variant="outline-danger" size="sm" target="_blank">Visit website</Button>
                        </Col>
                    </Row>
                </div>
            </div>

            <div className='aboutus_mainspace products_backgroundcolor'>
            	<br/>
                <h6 data-aos="fade-right" id='SS12' className='successstories_headingalign' ref={this.SS12} >Malnad Kitchen</h6>
                <br/>
                <div className='successstories_contentspace' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={MALNAD} alt='Malnad Kitchen Website snapshot photo' className='successstories_imagedisplay1' />
                            </div>
                        <p>
                        <strong>
                            E-commerce and product profile website for homemade food products and catering services
                            with a wide range of food categories and having a strong base of satisfied customers in Karnataka
                            serving over 20 years of delight taste.</strong>
                        </p>
                        <Button href="https://www.malnadkitchen.com/" variant="outline-danger" size="sm" target="_blank">Visit website</Button>
                        </Col>

                        <Col  xs lg="5"  className='successstories_imagedisplay2'  >
                            <div>
                                <img src={MALNAD} alt='Malnad Kitchen Website snapshot photo'/>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>


            <div id='SS13' className='aboutus_mainspace' ref={this.SS13}>
                <br/>
                <h6 data-aos="fade-right" id='SS13' className='successstories_headingalign' >Scholar Monks Foundation</h6>
                <br/>

                <div className='successstories_contentspace successstories_imagedisplay2' >
                    <Row className="justify-content-md-">
                        <Col xs lg="5" data-aos="fade-right" >
                            <div>
                        <img src={SCHOLAR} alt='Scholar Monks Foundation Website snapshot photo'/>
                            </div>
                        </Col>
                        <Col data-aos="fade-left" >
                        <p>
                        <strong>
                            Organization website for Scholar Monks Foundation which is a Social Welfare Startup
                            initiation which facilitates the Scholarship program for the Students & Education institutions
                            of Karnataka.</strong>
                        </p>
                        </Col>
                    </Row>
                </div>

                <div className='successstories_contentspace successstories_imagedisplay1' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={SCHOLAR} alt='Scholar Monks Foundation Website snapshot photo'/>
                            </div>
                            <p>
                        <strong>
                            Organization website for Scholar Monks Foundation which is a Social Welfare Startup
                            initiation which facilitates the Scholarship program for the Students & Education institutions
                            of Karnataka.</strong>
                        </p>
                        </Col>
                    </Row>
                </div>
            </div>

            <div className='aboutus_mainspace products_backgroundcolor'>
                <br/>
                <h6 data-aos="fade-right" id='SS14' className='successstories_headingalign' ref={this.SS14}>ISVM Conference 2020</h6>
                <br/>
                <div className='successstories_contentspace' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={ISVM} alt='ISVM Conference 2020 Website snapshot photo' className='successstories_imagedisplay1' />
                            </div>
                        <p>
                        <strong>
                            Conference website with Online Registration and Abstract submission for 38th ISVM
                            Annual Convention and National Symposium 2020 on “Advancement in Veterinary Medicine
                            in Mitigating Challenges to Animal Health” organized by Indian Society for Veterinary
                            Medicine at Veterinary College, Bangalore.</strong>
                        </p>
                        </Col>
                        <Col  xs lg="5"  className='successstories_imagedisplay2'  >
                            <div>
                                <img src={ISVM} alt='ISVM Conference 2020 Website snapshot photo'/>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <div id='SS15' className='aboutus_mainspace' ref={this.SS15}>
                <br/>
                <h6 data-aos="fade-right" id='SS15' className='successstories_headingalign' >CSI St. Thomas Church</h6>
                <br/>

                <div className='successstories_contentspace successstories_imagedisplay2' >
                    <Row className="justify-content-md-">
                        <Col xs lg="5" data-aos="fade-right" >
                            <div>
                        <img src={CSIs} alt='CSI St. Thomas Church Software snapshot photo' />
                            </div>
                        </Col>
                        <Col data-aos="fade-left" >
                        <p>
                        <strong>
                            Internal management software for CSI Church, that will keep track of the community members
                            and family details along with donations details towards the church.<br/></strong>
                        </p>
                        </Col>
                    </Row>
                </div>

                <div className='successstories_contentspace successstories_imagedisplay1' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={CSIs} alt='CSI St. Thomas Church Software snapshot photo' />
                            </div>
                            <p>
                        <strong>
                            Internal management software for CSI Church, that will keep track of the community members
                            and family details along with donations details towards the church.<br/></strong>
                        </p>
                        </Col>
                    </Row>
                </div>
            </div>

            <div className='aboutus_mainspace products_backgroundcolor'>
            <br/>
                <h6 data-aos="fade-right" id='SS16' className='successstories_headingalign' ref={this.SS16}>AMST Conference 2020</h6>
                <br/>
                <div className='successstories_contentspace' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={AMSTs} alt='AMST Conference 2020 Website snapshot photo' className='successstories_imagedisplay1' />
                            </div>
                        <p>
                        <strong>
                            Conference website with Online Registration and Abstract submission for 5th Annual Convention
                            of AMST and National Symposium 2020 on “Augmenting Sustainable Production, Processing and Safety
                            of Foods of Animal origin in Changing Climatic Scenario in India” organized at Veterinary College,
                            Bengaluru.</strong>
                        </p>
                        </Col>
                        <Col  xs lg="5" className='successstories_imagedisplay2' >
                            <div>
                                <img src={AMSTs} alt='AMST Conference 2020 Website snapshot photo'/>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <div id='SS17' className='aboutus_mainspace' ref={this.SS17}>
                <br/>
                <h6 data-aos="fade-right" id='SS17' className='successstories_headingalign' >Veterinary College</h6>
                <br/>

                <div className='successstories_contentspace successstories_imagedisplay2' >
                    <Row className="justify-content-md-">
                        <Col xs lg="5" data-aos="fade-right" >
                            <div>
                        <img src={CLINICALs} alt='Veterinary College Software snapshot photo' />
                            </div>
                        </Col>
                        <Col data-aos="fade-left" >
                        <p>
                        <strong>
                            Customized patient record management software for Veterinary Clinical,
                            which keeps track of all the patient history while keeping the record
                            about the appointments, medication, payment details of all the previous
                            pets making the job of the doctor and receptionist much easier with
                            customized data export options.<br/></strong>
                        </p>
                        </Col>
                    </Row>
                </div>

                <div className='successstories_contentspace successstories_imagedisplay1' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={CLINICALs} alt='Veterinary College Software snapshot photo' />
                            </div>
                            <p>
                        <strong>
                            Customized patient record management software for Veterinary Clinical,
                            which keeps track of all the patient history while keeping the record
                            about the appointments, medication, payment details of all the previous
                            pets making the job of the doctor and receptionist much easier with
                            customized data export options.<br/></strong>
                        </p>
                        </Col>
                    </Row>
                </div>
            </div>

            <div className='aboutus_mainspace products_backgroundcolor'>
            <br/>
                <h6 data-aos="fade-right" id='SS18' className='successstories_headingalign' ref={this.SS18}> DSC Tracker</h6>
                <br/>
                <div className='successstories_contentspace' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={DSCs} alt='DSC Tracker Software snapshot photo' className='successstories_imagedisplay1' />
                            </div>
                        <p>
                        <strong>
                            DSC and document tracking software for CA/CS enterprise. Helps in easy maintenance of
                            important documents and DSC tokens of their clients. Keep track of all the client’s company documents
                            in one platform and know the status of those documents just with a click of a button.</strong>
                        </p>
                        </Col>
                        <Col  xs lg="5" className='successstories_imagedisplay2' >
                            <div>
                                <img src={DSCs} alt='DSC Tracker Software snapshot photo' />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>


            <div id='SS19' className='aboutus_mainspace' ref={this.SS19}>
                <br/>
                <h6 data-aos="fade-right" id='SS19' className='successstories_headingalign' >Techno Rings</h6>
                <br/>

                <div className='successstories_contentspace successstories_imagedisplay2' >
                    <Row className="justify-content-md-">
                        <Col xs lg="5" data-aos="fade-right" >
                            <div>
                        <img src={Technorings} alt='Techno Rings Dashboard snapshot photo' />
                            </div>
                        </Col>
                        <Col data-aos="fade-left" >
                        <p>
                        <strong>
                            Data logger and a dashboard to power the products of Industry 4.0. Real time foundry
                            data will be sent wirelessly to the software and used for further production management
                            and data analytics through the dashboard and customized data export options.<br/></strong>
                        </p>
                        </Col>
                    </Row>
                </div>

                <div className='successstories_contentspace successstories_imagedisplay1' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={Technorings} alt='Techno Rings Dashboard snapshot photo' />
                            </div>
                            <p>
                        <strong>
                            Data logger and a dashboard to power the products of Industry 4.0. Real time foundry
                            data will be sent wirelessly to the software and used for further production management
                            and data analytics through the dashboard and customized data export options.<br/></strong>
                        </p>
                        </Col>
                    </Row>
                </div>
            </div>

            <div className='aboutus_mainspace products_backgroundcolor'>
            <br/>
                <h6 data-aos="fade-right" id='SS20' className='successstories_headingalign' ref={this.SS20}>EI-Learn</h6>
                <br/>
                <div className='successstories_contentspace' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={EILEARN} alt='EI-Learn Online learning portal snapshot photo' className='successstories_imagedisplay1' />
                            </div>
                        <p>
                        <strong>
                            Online learning portal for students to access the webinars, sessions or
                            classes by their educators, trainers and educational institutions having the
                            access to upload their recorded webinars or live sessions to share with the student
                            community. This also helps in keeping track of student engagements with the shared video sessions.<br/></strong>
                        </p>
                        </Col>
                        <Col  xs lg="5" className='successstories_imagedisplay2'>
                            <div>
                                <img src={EILEARN} alt='EI-Learn Online learning portal snapshot photo'  />
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <div id='SS21' className='aboutus_mainspace' ref={this.SS21}>
                <br/>
                <h6 data-aos="fade-right" id='SS21' className='successstories_headingalign' >Wireless Motor Control</h6>
                <br/>

                <div className='successstories_contentspace successstories_imagedisplay2' >
                    <Row className="justify-content-md-">
                        <Col xs lg="5" data-aos="fade-right" >
                            <div>
                        <img src={WirelessMotor} alt='Wireless Motor Controller Hardware'/>
                            </div>
                        </Col>
                        <Col data-aos="fade-left" >
                        <p>
                            <strong>
                                RF-based wireless Joystick and switch control to operate various
                                power motors for the areca tree climbing robot for the agriculture
                                automation<br/>
                            </strong>
                        </p>
                        </Col>
                    </Row>
                    <br/>
                </div>

                <div className='successstories_contentspace successstories_imagedisplay1' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={WirelessMotor} alt='Wireless Motor Controller Hardware'/>
                            </div>
                            <p>
                            <strong>
                                RF-based wireless Joystick and switch control to operate various
                                power motors for the areca tree climbing robot for the agriculture
                                automation<br/>
                            </strong>
                        </p>
                        </Col>
                    </Row>
                </div>
            </div>

            <div className='aboutus_mainspace products_backgroundcolor'>
            <br/>
                <h6 data-aos="fade-right" id='SS22' className='successstories_headingalign' ref={this.SS22}>Oil Blending Hardware</h6>
                <br/>
                <div className='successstories_contentspace' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={OilBlending} alt='Oil Blending controller Hardware' className='successstories_imagedisplay1  successstories_embimagesize' />
                            </div>
                        <p>
                            <strong>
                                Relay based, Temperature controlled IoT circuit board design
                                for Oil blending Machine in organic soap manufacturing unit.<br/>
                            </strong>
                        </p>
                        </Col>
                        <Col  xs lg="5" className='successstories_imagedisplay2' >
                            <div>
                                <img src={OilBlending} alt='Oil Blending controller Hardware' className='successstories_embimagesize' />
                            </div>
                        </Col>
                    </Row>
                    <br/>
                </div>
            </div>

            <div id='SS23' className='aboutus_mainspace' ref={this.SS23}>
                <br/>
                <h6 data-aos="fade-right" id='SS23' className='successstories_headingalign' >Time Logger</h6>
                <br/>

                <div className='successstories_contentspace successstories_imagedisplay2' >
                    <Row className="justify-content-md-">
                        <Col xs lg="5" data-aos="fade-right" >
                            <div>
                        <img src={TimeLogger} alt='IoT based Time logger' className='successstories_embimagesize' />
                            </div>
                        </Col>
                        <Col data-aos="fade-left" >
                        <p>
                            <strong>
                                480 Sec procedure time logger for foundries. Start time and end
                                time with the remaining time will be sent wirelessly to the software
                                and used for further production management and data analytics<br/>
                            </strong>
                        </p>
                        </Col>
                    </Row>
                    <br/>
                </div>

                <div className='successstories_contentspace successstories_imagedisplay1' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={TimeLogger} alt='IoT based Time logger' className='successstories_embimagesize' />
                            </div>
                            <p>
                            <strong>
                                480 Sec procedure time logger for foundries. Start time and end
                                time with the remaining time will be sent wirelessly to the software
                                and used for further production management and data analytics<br/>
                            </strong>
                        </p>
                        </Col>
                    </Row>
                </div>
            </div>

            {/* <div className='aboutus_mainspace products_backgroundcolor'>
            <br/>
                <h6 data-aos="fade-right" id='SS24' className='successstories_headingalign' ref={this.SS24}>Biometric Lock</h6>
                <br/>
                <div className='successstories_contentspace' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={FingerPrinting} alt='Biometric Lock' className='successstories_imagedisplay1 successstories_embimagesize' />
                            </div>
                        <p>
                            <strong>
                                A fingerprint-based lock system will be placed in the bag and it will
                                be opened only by the biometric access of the authorized person.<br/>
                            </strong>
                        </p>
                        </Col>
                        <Col  xs lg="5" className='successstories_imagedisplay2 ' >
                            <div>
                                <img src={FingerPrinting} alt='Biometric Lock' className='successstories_embimagesize' />
                            </div>
                        </Col>
                    </Row>
                    <br/>
                </div>
            </div> */}

            {/* <div id='SS25' className='aboutus_mainspace' ref={this.SS25}>
                <br/>
                <h6 data-aos="fade-right" id='SS25' className='successstories_headingalign' >Power Supply Timer</h6>
                <br/>

                <div className='successstories_contentspace successstories_imagedisplay2' >
                    <Row className="justify-content-md-">
                        <Col xs lg="5" data-aos="fade-right" >
                            <div>
                        <img src={PST} alt='Power supply timer' className=' embedded_ssimagepst' />
                            </div>
                        </Col>
                        <Col data-aos="fade-left" >
                        <p>
                            <strong>
                                The power supply adapter will have an adjustable knob and select
                                switches to set the timer and depending on that power supply will
                                be cut off to the load once the timer reaches the target time.<br/>
                            </strong>
                        </p>
                        </Col>
                    </Row>
                </div>

                <div className='successstories_contentspace successstories_imagedisplay1' >
                    <Row className="justify-content-md-center">
                        <Col data-aos="fade-right">
                            <div>
                                <img src={PST} alt='Power supply timer' className=' embedded_ssimagepst' />
                            </div>
                            <p>
                            <strong>
                                The power supply adapter will have an adjustable knob and select
                                switches to set the timer and depending on that power supply will
                                be cut off to the load once the timer reaches the target time.<br/>
                            </strong>
                        </p>
                        </Col>
                    </Row>
                </div>
            </div> */}

            <Footer/>
        </div>
    )
}
}

export default SuccessStories
